import Loading from "../../components/Loading";
import { RenderFields } from "../../utils/form.utils";
import FormSectionTitle from "../../components/styled/FormSectionTitle";

export default function CustomerField({ watch, control, errors, setValue }) {
  const fields = [
    {
      label: "Name",
      name: "customer.name",
      type: "text",
      placeholder: "Name",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Designation",
      name: "customer.designation",
      type: "text",
      placeholder: "Designation",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Account Name",
      name: "customer.account_name",
      type: "text",
      placeholder: "Account Name",
      col: { md: 4, lg: 3 }
    },
    {
      label: "Address",
      name: "customer.address",
      type: "textarea",
      placeholder: "Address",
      col: { md: 12 }
    }
  ];

  const isLoading = false;

  return (
    <>
      <div className="col-12">
        <FormSectionTitle>Customer Information</FormSectionTitle>
      </div>
      <Loading loading={isLoading} />
      <RenderFields
        setValue={setValue}
        fields={fields}
        control={control}
        watch={watch}
        errors={errors}
      />
    </>
  );
}
